import React from 'react'
import { ProgressBar } from 'react-bootstrap'
import jazzicon from '@metamask/jazzicon'
import { useUser } from '../contexts/userContext'
import identiconFactory from '../services/wallet/identicon'
import { formatAddress } from '../utils'

const identicon = identiconFactory(jazzicon)
const identiconSize = 16 // px

export const ProgressNavBar = ({
  noBack,
  goBack,
  step,
  totalSteps,
  stageName,
  rightChildren,
  showProgress = true,
  showWallet = true,
  ...props
}) => {
  const { user } = useUser()
  const account = user?.account

  const backButton = (
    <div className='back-arrow' onClick={goBack} data-attr='back'>
      <i className='bi bi-arrow-left-short' data-attr='back'></i>
    </div>
  )

  const identiconSvg =
    account && identicon.iconForAddress(account, identiconSize).innerHTML

  return (
    <div {...props}>
      <div className='progress-nav'>
        {!noBack && backButton}
        {showProgress && (
          <div className='progress-container'>
            <div className='progress-text'>{stageName}</div>
            <div className='progress-bar'>
              <ProgressBar variant='primary' now={(step * 100) / totalSteps} />
            </div>
          </div>
        )}
      </div>
      {showWallet && account && (
        <div className='wallet ms-4'>
          <span>{formatAddress(account)}</span>
          {identiconSvg && (
            <div
              className='identicon ms-2'
              dangerouslySetInnerHTML={{ __html: identiconSvg }}
              style={{
                width: identiconSize,
                height: identiconSize
              }}
            ></div>
          )}
        </div>
      )}
    </div>
  )
}

export default ProgressNavBar
